import { motion } from "framer-motion";
import { ArrowRight, PlayCircle } from "lucide-react";
import { useLang } from "../../context/LanguageContext";

export const embedUrl = (url = "") => {
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([\w-]+)/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const vm = url.match(/vimeo\.com\/(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  return null;
};

export const VideoBlock = ({ block, onDone }) => {
  const { t } = useLang();
  const src = embedUrl(block.url || "");
  const fileSrc = (block.url || "").startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${block.url}` : block.url;
  return (
    <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="card-dark p-7 sm:p-11" data-testid="academy-video">
      <span className="badge-lime inline-flex items-center gap-1.5"><PlayCircle className="w-3.5 h-3.5" /> {t("learn.video")}</span>
      {block.title && <h2 className="font-heading font-black text-2xl sm:text-4xl text-[#0B1B3A] mt-5 leading-tight" data-testid="academy-video-title">{block.title}</h2>}
      <div className="mt-7 rounded-[22px] overflow-hidden border border-[#E2E8F0] bg-black aspect-video">
        {src ? (
          <iframe src={src} title={block.title || "video"} className="w-full h-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-testid="academy-video-iframe" />
        ) : (
          <video controls crossOrigin="use-credentials" className="w-full h-full" src={fileSrc} data-testid="academy-video-player" />
        )}
      </div>
      {block.note && <p className="text-sm text-[#0B1B3A] font-semibold mt-6 leading-relaxed rounded-[22px] bg-[#EEF4FF] p-5" data-testid="academy-video-note">{block.note}</p>}
      <button data-testid="academy-video-next" onClick={() => onDone(true)} className="btn-blue mt-8">
        {t("academy.nextSlide")} <ArrowRight className="w-4 h-4" />
      </button>
    </motion.div>
  );
};

export default VideoBlock;
